import type { Product } from "../products/hooks/useProducts";

export type GstOverrideType = "none" | "manual_rate" | "no_tax";

export type PosCartItem = {
  product_id: string;
  name: string;
  quantity: number;
  unit_price: number;
  mrp: number | null;
  available_qty: number;
  gst_override_type: GstOverrideType | null;
  gst_override_value: number | null;
  gst_override_reason: string;
};

export type PosGstLineBreakdown = {
  taxable: number;
  gst: number;
  cgst: number;
  sgst: number;
  total: number;
  effectiveRatePercent: number | null;
  isCompliant: boolean;
};

export function getProductGstConfig(product: Product | undefined): {
  isGstApplicable: boolean;
  gstType: "inclusive" | "exclusive" | null;
  gstRatePercent: number | null;
} {
  if (!product) {
    return { isGstApplicable: false, gstType: null, gstRatePercent: null };
  }
  const applicable = Boolean(product.is_gst_applicable);
  const t = product.gst_type === "inclusive" || product.gst_type === "exclusive" ? product.gst_type : null;
  const r = product.gst_rate != null && product.gst_rate !== "" ? Number.parseFloat(String(product.gst_rate)) : null;

  return {
    isGstApplicable: applicable,
    gstType: t,
    gstRatePercent: Number.isFinite(r as number) ? (r as number) : null,
  };
}
